import React from 'react';

import { UseFormReturn } from 'react-hook-form';

import { getAirOptionsLoader } from 'api/flightApi/searchForFlight';
import { EOrganizedBy, IAirline, IAirport, IApiFlightTripEvent, IFlightAPIEventData } from 'detailsv2/structure';

type Props = {
  tripEvent: IApiFlightTripEvent;
  methods: UseFormReturn;
  organizedBy?: EOrganizedBy;
};

export const useFlightApi = (props: Props) => {
  const data = props.tripEvent.data as IFlightAPIEventData;
  const [showSelect, setShowSelect] = React.useState(!props.tripEvent.id);
  const [searchResults, setSearchResults] = React.useState<IFlightAPIEventData[] | null>(data.airline ? [data] : null);

  const isNoData = searchResults?.length === 0;

  const loadAirlineOptions = getAirOptionsLoader(airOptionAdapter, 'airlines');
  const loadAirportOptions = getAirOptionsLoader(airOptionAdapter, 'airports');

  return {
    isNoData,
    loadAirlineOptions,
    loadAirportOptions,

    searchResults,
    setSearchResults,

    showSelect,
    setShowSelect,
  };
};

export function airOptionAdapter(page: IAirport | IAirline, withFsCode: boolean) {
  const name = withFsCode ? `${page.name} (${page.fsCode})` : page.name;

  return {
    value: page.id,
    label: name,
    name,
    id: page.id,
    fsCode: page.fsCode,
  };
}
